export default __webpack_public_path__ + "static/blog-placeholder-9d594c63b91c0fd68ab352790cf33f66.png";